import minimumBillableHoursMd from './minimum_billable_hours.md?raw';
import allowHalfDaysMd from './half_day_billing.md?raw';
import halfDayHoursMd from './half_day_threshold.md?raw';
import halfDayRateMethodMd from './half_day_rate_method.md?raw';
import billingStructureMd from './billing_structure.md?raw';
import { registerHelpContent } from '@/components/ui/help-registry';

export const fieldDescriptions = {
  minimum_billable_hours: minimumBillableHoursMd,
  allow_half_days: allowHalfDaysMd,
  half_day_hours: halfDayHoursMd,
  half_day_rate_method: halfDayRateMethodMd,
} as const;

// Register static deep-link targets so navigation works even when
// the target HelpButton isn't mounted (e.g., DayRateConfigForm hidden)
registerHelpContent({
  'Billing Structure': billingStructureMd,
  'Half-Day Billing': allowHalfDaysMd,
  'Half-Day Rate Method': halfDayRateMethodMd,
  'Minimum Billable Hours': minimumBillableHoursMd,
  'Half-Day Threshold': halfDayHoursMd,
  'Half Day Threshold': halfDayHoursMd, // alternate spelling used in markdown backticks
});
